export enum EnumEmployeeTimeSheet {
    checkin = 0,
    checkout = 1,
}

export enum TypeLinkRegister {
    LinkUnico = 0,
    LinkCompleto = 1,
    AtualizarFoto = 2
}